/**
 * Appends a width parameter to CDN image URLs for resized delivery.
 */
export function getResizedImageUrl(url: string, width: number): string {
  if (!url) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}width=${width}`;
}

// Suffixes without dot — matches both ".mp4" and "mp4" (Brandfolder CDN strips dots from filenames)
const VIDEO_SUFFIXES = ['mp4', 'webm', 'mov', 'avi', 'mkv', 'm4v', 'ogv'];

/**
 * Detect whether a CDN URL points to a video file based on its extension.
 * Handles both standard extensions (.mp4) and Brandfolder CDN URLs where
 * dots are stripped from filenames (e.g., "filemp4" instead of "file.mp4").
 */
export function isVideoUrl(url: string): boolean {
  if (!url) return false;
  try {
    const pathname = new URL(url, 'https://placeholder.com').pathname.toLowerCase();
    return VIDEO_SUFFIXES.some(ext => pathname.endsWith(ext));
  } catch {
    const lower = url.toLowerCase();
    return VIDEO_SUFFIXES.some(ext => lower.endsWith(ext) || lower.includes('.' + ext));
  }
}
